/** 
 * 在图片加载完成前显示loading
 */

//判断浏览器
var Browser = new Object();
Browser.userAgent=window.navigator.userAgent.toLowerCase();
Browser.ie=/msie/.test(Browser.userAgent);
Browser.Moz=/gecko/.test(Browser.userAgent);

//判断是否加载完成
function setImage(imgTag,imgUrl,callback){    
  var time1 = new Date().getTime();
  var imgObj = new Image();
  // 没有使用回调函数时，默认checkImg函数
  if(!callback){ callback = checkImg }
  if(Browser.ie){
        imgObj.onreadystatechange =function(){  
            if(imgObj.readyState == "complete" || imgObj.readyState == "loaded"){
              checkImg(imgObj,imgTag);
              if(callback){callback()};
            }
        }        
  } else if(Browser.Moz){
        imgObj.onload = function(){
            if(imgObj.complete == true){
              checkImg(imgObj,imgTag);
              if(callback){ callback() };
            }
        }        
  }    
  //如果因为网络或图片的原因发生异常，则显示该图片
  imgObj.onerror = function(){
    imgObj.src = 'https://cdn.shopify.cn/s/files/1/0278/2933/8225/files/NO-IMAGE-big.jpg';
  }
  imgObj.src = imgUrl;
}

//显示图片
function checkImg(imgObj,imgTag){
  $(imgTag).attr("src",imgObj.src);
}